import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateBufferTankOperatingMode',
})
export class TranslateBufferTankOperatingModePipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}
  transform(value: string): string {
    if (value && this.customTranslationsService.BUFFER_TANK_OPERATING_MODES[value]) {
      return this.translateService.instant(
        this.customTranslationsService.BUFFER_TANK_OPERATING_MODES[value] ?? value
      );
    }

    return value;
  }
}
